import { render, staticRenderFns } from "./EventDataAtAGlance.vue?vue&type=template&id=144300ce&scoped=true&"
import script from "./EventDataAtAGlance.vue?vue&type=script&lang=js&"
export * from "./EventDataAtAGlance.vue?vue&type=script&lang=js&"
import style0 from "./EventDataAtAGlance.scss?vue&type=style&index=0&id=144300ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144300ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText,VCardTitle})
